export default {
      id: "e-mail-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#e-mail",
      toString: function () {
        return this.url;
      }
    }